export { default as OutsidePressHandler, EventProvider as OutsidePressProvider } from 'react-native-outside-press'
